import $ from 'jquery';
import { editorConfig } from '~config';
import { setSvgColor } from '~src/ui';

export const updateShadowValuesFromActiveObject = () => {
  if (!window.canvas.getActiveObject()) {
    return;
  }
  let shadow = window.canvas.getActiveObject().get('shadow');

  if (!shadow) {
    $('#editor-menu-remove-shadow').attr('disabled', true);
    shadow = {
      color: 'rgba(160, 160, 160, 0.3)',
      offsetX: 7,
      offsetY: 2,
      blur: 4,
    };
    setSvgColor('#img-shadow-object', editorConfig.styles.inactiveControlColor);
  } else {
    setSvgColor('#img-shadow-object', editorConfig.styles.activeControlColor);
    $('#editor-menu-remove-shadow').attr('disabled', false);
  }

  if (shadow.color) {
    $('#color-shadow').css('background-color', shadow.color);
    $('#editor-object-opacity-slider').val(0.3);
  }

  if (shadow.blur) {
    $('#editor-object-blur-slider').val(shadow.blur);
  }
  if (shadow.offsetX) {
    $('#editor-object-offset-h-slider').val(shadow.offsetX);
  }
  if (shadow.offsetY) {
    $('#editor-object-offset-v-slider').val(shadow.offsetY);
  }
};
